
<template>
    
        <div>
            <e-charts style="width:1300px" :options="bar" ref="bar" theme="ovilia-green" auto-resize />
        </div>

  
</template>

<script>
import ECharts from 'vue-echarts/components/ECharts'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import 'echarts/lib/chart/bar'
import theme from './theme.json'

//ECharts.registerTheme('ovilia-green', theme)

export default {
    data() {
        return {
            bar: {
                legend: {},
                tooltip: {},
                dataset: {
                    // Provide data.
                    source: [
                        ['Comparativo', 'Deseado'],
                        ['Presentación Personal', 5,5,100],
                        ['Bienvenida', 10,10,100],
                        ['Personalización', 35,25,100],
                        ['Impulso Comercial', 20,15,100],
                        ['Servicio al Cliente', 20,10,100],
                        ['Cierre ', 10,5,100]
                    ]
                },
                // Declare X axis, which is a category axis, mapping
                // to the first column by default.
                xAxis: { type: 'category' },
                // Declare Y axis, which is a value axis.
                yAxis: {},
                // Declare several series, each of them mapped to a
                // column of the dataset by default.
                series: [{ type: 'bar' }]

            },
        }
    },
    methods: {
      
    },
    components: {
        ECharts
    }
}
</script>